import { shopScene } from '../shopkit.js';

/** 当铺：可以抵押也可以赎回，规矩最死的一家。 */
export const pawnDoc = shopScene({
  id: 'pawn',
  name: '当铺',
  shop: 'pawn',
  owner: '朝奉先生',
  desc: '柜台比人高，隔着栅栏看人先看衣裳。',
  w: 20, h: 16,
  counters: [{ gx: 7, gy: 3, len: 5, kind: 'pawn' }],
  props: [
    { type: 'locked_display_case', gx: 4, gy: 5 },
    { type: 'ledger_shelf', gx: 15, gy: 5 },
    { type: 'boss_chair', gx: 9, gy: 6 },
    { type: 'locked_box', gx: 15, gy: 11 },
    { type: 'incense_burner', gx: 3, gy: 11 },
  ],
  portals: [
    { to: 'market', gx: 10, gy: 15, spawn: [5, 9], label: '回市集' },
  ],
});

export default pawnDoc;
